<div class="batch-popover-shell">
  <div class="batch-popover__close-wrap">
    <button
      type="button"
      class="btn btn3 batch-popover__close"
      rounded="full"
      aria-label="Chiudi dettaglio lotto"
      (click)="popoverCtrl.dismiss()"
      style="
        background-color: #e90000;
        color: #ffffff;
        width: 35px !important;
        height: 35px !important;
      "
    >
      <i
        class="bx bx-x bx-sm posRelBox2"
        style="
          color: #ffffff;
          bottom: 10px;
          position: relative !important;
          left: -80% !important;
          top: -1px !important;
        "
      ></i>
    </button>
  </div>

  <div class="batch-popover">
    <div class="batch-popover__hero">
      <div class="batch-popover__hero-main">
        <h2 class="batch-popover__title">
          Lotto n.
          {{ (getProduct | async)?.product_code || "Articolo non disponibile" }}
        </h2>

        <!-- <span class="batch-popover__badge">
          <i class="bx bx-package"></i>
        </span> -->
      </div>

      <!-- <div class="batch-popover__meta">
        <p class="batch-popover__subtitle">
          {{
            (getProduct | async)?.product_description ||
              "Nessun articolo selezionato"
          }}
        </p>
      </div> -->
    </div>

    <section class="batch-summary-card">
      <div class="batch-summary-card__label">
        <i class="bx bx-package"></i>
        <span>Quantità:</span>
      </div>

      <div>
        <article class="batch-stat-card">
          <span class="batch-stat-card__label">Quantità</span>
          <strong class="batch-stat-card__value">
            {{ (getBatch | async)?.quantity || "-" }}
          </strong>
        </article>
      </div>
    </section>

    <section class="batch-summary-card">
      <div class="batch-summary-card__label">
        <i class="bx bx-calendar"></i>
        <span>Periodo:</span>
      </div>

      <div class="batch-summary-card__values">
        <article class="batch-stat-card">
          <span class="batch-stat-card__label">Settimana</span>
          <strong class="batch-stat-card__value">
            {{ (getBatch | async)?.batch_week || "-" }}
          </strong>
        </article>

        <article class="batch-stat-card">
          <span class="batch-stat-card__label">Anno</span>
          <strong class="batch-stat-card__value">
            {{ (getBatch | async)?.batch_year || "-" }}
          </strong>
        </article>
      </div>
    </section>

    <section class="batch-summary-card">
      <div class="batch-summary-card__label">
        <i class="bx bx-barcode"></i>
        <span>Range seriali:</span>
      </div>

      <div class="batch-summary-card__values">
        <article class="batch-stat-card">
          <span class="batch-stat-card__label">Da..</span>
          <strong class="batch-stat-card__value">
            {{ (getBatch | async)?.serial_from || "-" }}
          </strong>
        </article>

        <article class="batch-stat-card">
          <span class="batch-stat-card__label">a..</span>
          <strong class="batch-stat-card__value">
            {{ (getBatch | async)?.serial_to || "-" }}
          </strong>
        </article>
      </div>
    </section>

    <section class="batch-documents">
      <div class="batch-documents__header">
        <span>Certificazioni</span>
        <span class="batch-documents__count">
          {{ (getBDocuments | async)?.length || 0 }}
        </span>
      </div>

      <div class="batch-documents__body">
        @if ((getBDocuments | async)?.length) {
          <div class="batch-documents__list">
            @for (
              certificate of getBDocuments | async;
              track certificate.supplier_certificate_document_id
            ) {
              <article class="batch-document-row">
                <div class="batch-document-row__content">
                  <p class="batch-document-row__title">
                    {{ certificate?.document_description }}
                  </p>
                  <span class="batch-document-row__meta">
                    {{ (getProduct | async)?.product_code }}
                  </span>
                </div>

                <div class="batch-document-row__actions">
                  @if (certificate.document_url) {
                    <a
                      class="batch-document-row__action batch-document-row__action--pdf"
                      href="{{ certificate?.document_url }}"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Apri documento PDF"
                    >
                      <i class="bx bxs-file-pdf bx-sm"></i>
                    </a>
                  }
                </div>
              </article>
            }
          </div>
        } @else {
          <p class="batch-documents__empty">
            Nessun certificato disponibile per questo lotto.
          </p>
        }
      </div>
    </section>
  </div>
</div>
